import { ProofOfFundsDocument2, ProofOfFundsDocument3, TProofOfFundsDocument2Codec, TProofOfFundsDocument3Codec } from "../ProofOfFundsDocument";
import { partial, TPartialCodec } from "../../../shared/src/codecs/types/partial";
import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { fileIO, TFileIOCodec } from "../../../shared/src/codecs/types/fileIO";
import { intersection, TIntersectionCodec } from "../../../shared/src/codecs/types/intersection";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";

export const ProofOfFundsDocumentFileIO: TFileIOCodec<
    TIntersectionCodec<[
        TProofOfFundsDocument3Codec,
        TPartialCodec<{
            request_ref: TAnyStringCodec;
        }>
    ]>,
    TProofOfFundsDocument2Codec
> = fileIO(
    intersection([
        ProofOfFundsDocument3,
        partial({
            request_ref: string(),
        }),
    ]),
    ProofOfFundsDocument2,
);

export type TProofOfFundsDocumentFileIOCodec = typeof ProofOfFundsDocumentFileIO;
export type TProofOfFundsDocumentFileIO = TTypeOfCodec<TProofOfFundsDocumentFileIOCodec>;
